export default function AuthHeader() {
    const token = localStorage.getItem('token');
  
    if (token) {
      return { 'x-access-token': token };
      console.log("tokenexist");
    } else {
      return {};
      console.log("no token");
    }
  }